<template>
<article class="results-list__item results-list__item--bills" data-id="results-list-item">
  <div class="bill-details bill-details--letter" :class="this.actionClass">
    <div v-if="!isFederalComments" class="bill-details__position" :class="this.positionClass">
      <div class="bill-details__position-text u-primary-title" :class="this.positionTypeClass">{{ item.position_friendly }}</div>
    </div>
    <div v-else class="results-list__item-img"></div>
    <div class="bill-details__content">
      <span class="results-list__tophat u-secondary-dark" v-if="!isFederalComments && (item.letter_type_friendly || item.type_friendly)">{{ item.letter_type_friendly ? item.letter_type_friendly : item.type_friendly }}</span>
      <h3 class="bill-details__title u-medium-title u-sans-serif u-sans-serif-title u-type-28 u-type-until-bp-small-24">
        <a :href="href" class="u-primary-very-dark u-hover-tertiary-dark">
          {{ item.title }}
        </a>
      </h3>
      <div class="bill-details__issue-date">
        <ul class="bill-details__issues" v-if=" item.issue_explainer_title">
          <template v-if="Array.isArray(item.issue_explainer_title)">
            <li class="bill-details__issue" v-for="(n, index) in 2">
              <a :href="item.issue_explainer_path[index]">{{ item.issue_explainer_title[index] }}</a>
            </li>
          </template>
          <template v-else>
            <li class="bill-details__issue" >
              <a :href="item.issue_explainer_path">{{ item.issue_explainer_title }}</a>
            </li>
          </template>
        </ul>
        <p class="bill-details__date u-sans-serif u-type-12 u-before-bg-primary-medium-dark" v-if="item.publish_date">Submitted on {{ item.publish_date | date }}</p>
        <p class="bill-details__date u-sans-serif u-type-12 u-before-bg-primary-medium-dark" v-if="item.updated_date">, Updated on {{ item.updated_date | date }}</p>
      </div><!--/.bill-details__issue-date-->
      <p class="bill-details__description u-sans-serif u-type-16" v-if="item.summary">{{ item.summary | strip }}</p>
    </div><!--/.bill-details__content-->

    <div class="bill-details__action" v-if="item.related_action_title">
      <div class="bill-details__action-inside" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions,}" :class="classes">
        <a class="bill-details__action-inside-link u-bg-primary-dark-gradient" :href="item.related_action_path">
          <p class="bill-details__action-tophat u-bg-secondary-dark" v-if="item.related_action_is_donate && item.related_action_is_donate === '1'">Donate</p>
          <p class="bill-details__action-tophat u-bg-secondary-dark" v-else>Take Action</p>
          <h4 class="bill-details__action-title u-medium-title u-sans-serif u-sans-serif-title u-type-20 u-type-until-bp-small-18">{{ item.related_action_title }}</h4>
          <span class="bill-details__action-cta btn btn--secondary btn--small">
                {{ item.related_action_cta }}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
                  <path fill="currentColor" fill-rule="nonzero" d="M75 18L91 22 75 26 77.228 22z" transform="translate(-75 -18)"></path>
                </svg>
              </span>
        </a>
      </div>
    </div>

  </div><!--/.bill-details-->
</article>

</template>

<script>

export default {
  name: 'ResultsListLetterItem',
  props: ['item'],
  data() {
    return {
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0.80, 0.20] // [0.25, 0.75] if you want a 25% offset!
      },
      classes: '',
    }
  },
  computed: {
    href () {
      if(this.item.path) {
        return this.item.path
      }
      else {
        return this.item.url
      }
    },
    title () {
      // PDFs and other indexed files do not have a path
      return this.item.path ? this.item.title : decodeURIComponent(this.item.url.substring(this.item.url.lastIndexOf('/') + 1));
      //return this.item.path ? this.item.title : this.truncateBody(5); // PDFs' flattened content
    },
    summary () {
      return this.item.path ? this.item.summary : this.truncateBody(25);
    },
    isFederalComments() {
      return this.route === 'federal_comments'
    },
    positionClass () {
      // @TODO TID constants?
      if(this.item.position_friendly==='Support') {
        return 'bill-details__position--good u-bg-secondary-light';
      }
      if(this.item.position_friendly==='Oppose') {
        return 'bill-details__position--bad u-bg-tertiary-very-dark';
      }
      return 'bill-details__position--neutral u-bg-primary-light';
    },
    positionTypeClass () {
      // @TODO TID constants?
      if(this.item.position_friendly==='Support' || this.item.position_friendly==='Oppose') {
        return 'u-type-28';
      }
      return 'u-type-20';
    },
    route () {
      return this.$route.name
    },
    actionClass () {
      return this.item.related_action_title ? ' bill-details--action' : ''
    }
  },
  methods: {
    onWaypoint({ going }) {
      // going: in, out
      if (going === this.$waypointMap.GOING_IN) {
        this.classes = 'is-in';
      }
    },
    isTruncatable(length, data) {
      return data.split(' ').length > (length - 1)
    },
    truncateBody(length) {
      // body contains PDFs' flattened content
      if (this.isTruncatable(length, this.item.body)) {
        return `${this.item.body.split(' ').slice(0, (length - 1)).join(' ')}...`
      }
      return this.item.body
    },
  }
}
</script>
